export default {
  data () {
    return {
      loading: false
    }
  },
  methods: {
    startAppLoading () {
      this.loading = true
    },
    finishAppLoading () {
      this.loading = false
    },
    isAppLoading () {
      return this.loading
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/HasLoading.mixin.js